import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Outlet } from "react-router";
import AuthGuard from "./components/AuthGuard";
import { ServiceWorkerAppClientProvider } from "./providers/ServiceWorkerAppProvider";
import { AppDashboardLayout } from "./layouts/AppDashboardLayout";
import {
  DirectusProvider,
  PWAProvider,
  ToastNotificationProvider,
} from "./providers";
import { FiltersProvider } from "./providers/FiltersProvider";
import { AppIndexedDbProvider } from "./providers/IndexDbProvider";
import { RouterAppProvider } from "./providers/RouterProvider";
import { SelectionProvider } from "./providers/SelectionProvider";
import { SettingsProvider } from "./providers/SettingsProvider";
import { GlobalErrorBoundary } from "./components/GlobalErrorBoundary";
import { DialogProvider } from "./providers/DialogProvider";

const queryClient = new QueryClient();

const theme = createTheme({
  colorSchemes: { light: true, dark: true },
});

function App() {
  return (
    <ToastNotificationProvider>
      <GlobalErrorBoundary>
        <AppIndexedDbProvider>
          <SettingsProvider>
            <SelectionProvider>
              <FiltersProvider>
                <DirectusProvider>
                  <AuthGuard>
                    <RouterAppProvider>
                      <QueryClientProvider client={queryClient}>
                        <PWAProvider>
                          <ThemeProvider theme={theme}>
                            <CssBaseline />
                            <ServiceWorkerAppClientProvider initialSyncDelayMs={15000}>
                              <AppDashboardLayout>
                                <DialogProvider>
                                  <Outlet />
                                </DialogProvider>
                              </AppDashboardLayout>
                            </ServiceWorkerAppClientProvider>
                          </ThemeProvider>
                        </PWAProvider>
                      </QueryClientProvider>
                    </RouterAppProvider>
                  </AuthGuard>
                </DirectusProvider>
              </FiltersProvider>
            </SelectionProvider>
          </SettingsProvider>
        </AppIndexedDbProvider>
      </GlobalErrorBoundary>
    </ToastNotificationProvider>
  );
}

export default App;
